/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Icon,
  SimpleGrid,
  Skeleton,
  Spacer,
  Switch,
  TabList,
  Tabs,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { GoogleMap, OverlayView, OverlayViewF, useJsApiLoader } from '@react-google-maps/api'
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useInfiniteQuery, useQuery } from 'react-query'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { AuthContext } from '../../App'
import { getVenueDetail, getVenueEvents } from '../../api/user/play/Play'
import EventDetailCard from '../../components/cards/EventDetailCard'
import EventGalleryCard from '../../components/cards/EventGalleryCard'
import { LocationMarkerDirection, MessageDots, SimpleLink } from '../../components/icons/icons'
import CustomTab from '../../components/input/CustomTab'
import CustomTags from '../../components/input/CustomTabs'
import DatePicker from '../../components/input/DatePicker'
import DatePickerSwipe from '../../components/input/DatePickerSwipe'
import CopyLinkModal from '../../components/modals/CommunityCopyLinkModal'
import PlayWaitlistJoinedModal from '../../components/modals/PlayWaitlistJoinedModal'
import handleToast from '../../components/toast/handleToast'
import useElementWidth from '../../hooks/useElementWidth'
import useMobile from '../../hooks/useMobile'
import { mapContainerStyle, mapStyles } from '../../theme/mapStyles'
// import combineDateTime from "../../functions/CombineDateTime";
import InfinityGrid, { getInfinityPages } from '../../components/datagrid/InfinityGrid'
import LazyBox from '../../components/lazy/LazyBox'
import { getSkillLevelDisplay } from '../../functions/Capitalize'
import { getEventLabel } from '../../types/EventTypes'

import BlankState from '../../components/input/BlankState'
//import { postSessionToken } from "../../api/admin/Events";

const getPixelPositionOffset = (width: any, _height: any) => ({
  x: -(width / 2),
  y: -98,
})

export function getGoogleMapsUrl(address: string) {
  const baseUrl = 'https://www.google.com/maps/'
  //replace in address the space with a + sign
  console.log(address)
  address = address.replace(' ', '+')
  address = address.replace(',', '')
  const queryParams = `?q=${address}`
  return `${baseUrl}${queryParams}`
}

export function getMapsUrl(address: string) {
  // Format address for URLs
  const formattedAddress = address.replace(/\s+/g, '+').replace(/,/g, '')

  // Check if running on iOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream

  // If on iOS, try to use Maps app first with Google Maps as fallback
  if (isIOS) {
    // Apple Maps URL format
    const appleMapsUrl = `maps://maps.apple.com/?q=${formattedAddress}`

    // Google Maps URL format
    const googleMapsUrl = `https://www.google.com/maps/?q=${formattedAddress}`

    // Try to open in Apple Maps first, falling back to Google Maps
    // We'll attempt to open Apple Maps by creating and clicking a hidden link
    const link = document.createElement('a')
    link.href = appleMapsUrl
    link.style.display = 'none'
    document.body.appendChild(link)

    // Set timeout to open Google Maps as fallback if Apple Maps doesn't open
    setTimeout(() => {
      window.open(googleMapsUrl, '_blank')
    }, 500)

    // Try to open Apple Maps
    link.click()

    // Clean up
    setTimeout(() => {
      document.body.removeChild(link)
    }, 1000)

    return appleMapsUrl // Return URL for reference, though we're handling opening directly
  } else {
    // For non-iOS devices, just use Google Maps
    return `https://www.google.com/maps/?q=${formattedAddress}`
  }
}

function formatDate(date: Date | null) {
  // Extract year, month, and day from the Date object
  if (!date) return ''

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // Month is zero-indexed, so add 1
  const day = String(date.getDate()).padStart(2, '0')

  // Construct the formatted date string in YYYY-MM-DD format
  const formattedDate = `${year}-${month}-${day}`

  return formattedDate
}

function formatTimeToAMPM(timeStr: string) {
  if (!timeStr) return ''
  // Split the time string into hours, minutes, and seconds
  const times = timeStr.split(':')
  const hours = times[0]
  const minutes = times[1]

  // Convert hours from string to number
  const hour = parseInt(hours)

  // Determine if it's morning (AM) or afternoon (PM)
  const period = hour < 12 ? 'AM' : 'PM'

  // Adjust the hour for 12-hour format
  const displayHour = hour > 12 ? hour - 12 : hour

  // Format the time in 12-hour format
  const formattedTime = `${displayHour}:${minutes} ${period}`

  return formattedTime
}

const MapCard = ({ venue }: { venue: any }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  })

  //const [map, setMap] = useState(null)
  //const [zoom, setZoom] = useState(8)

  const zoom = 12

  const center = {
    lat: venue?.data?.location.lat ?? 0,
    lng: venue?.data?.location.lng ?? 0,
  }

  const onLoad = useCallback(function callback(map: any) {
    //const bounds = new window.google.maps.LatLngBounds(center);
    map.setZoom(12)
    //setMap(map)
  }, [])
  const onUnmount = useCallback(function callback() {
    //setMap(null)
  }, [])

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      center={center}
      onLoad={onLoad}
      zoom={zoom}
      onUnmount={onUnmount}
      options={{
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControl: false,
        styles: mapStyles,
        minZoom: zoom - 5,
      }}
    >
      {venue.isSuccess && (
        <OverlayViewF
          position={{
            lat: venue.data.location.lat,
            lng: venue.data.location.lng,
          }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <Box
            w="90px"
            h="107px"
            bgImage="/components/map_pin.svg"
            bgPos="center"
            bgSize="contain"
            position="relative"
            onClick={() => window.open(getMapsUrl(venue?.data?.address))}
            cursor="pointer"
          >
            <LazyBox
              width={60}
              height={60}
              src={(venue?.data?.images?.length ?? 0 > 0) ? venue?.data?.images[0] : ''}
              top="15px"
              left="15px"
              borderRadius="30px"
            />
          </Box>
        </OverlayViewF>
      )}
    </GoogleMap>
  ) : (
    <Skeleton w="100%" h="100%" />
  )
}
const EventDetails = ({ venue, isMobile }: { venue: any; isMobile?: boolean }) => {
  const [hideDetails, setHideDetails] = useState(true)

  if (venue.isLoading || venue.isFetching) {
    return (
      <Box ml={isMobile ? '20px' : '0'}>
        <Skeleton height="20px" width="60px" mt="20px" mb="8px" />
        <Skeleton height="16px" width="100%" maxWidth="660px" mb="4px" />
        <Skeleton height="16px" width="80%" maxWidth="500px" mb="4px" />
        <Skeleton height="16px" width="60%" maxWidth="400px" mb="24px" />

        <Skeleton height="20px" width="100px" mt="20px" mb="8px" />
        <Skeleton height="16px" width="200px" mb="24px" />

        <Skeleton height="20px" width="150px" mt="20px" mb="8px" />
        <Skeleton height="16px" width="180px" mb="30px" />
      </Box>
    )
  }

  return (
    <Box ml={isMobile ? '20px' : '0'}>
      <Text variant="title" mt="20px" mb="8px" fontSize="17">
        About
      </Text>
      <Text
        variant="subtle"
        fontSize="13"
        //noOfLines={hideDetails ? 1 : 10}
        flexWrap="wrap"
        maxWidth="660px"
      >
        {hideDetails && venue?.data?.about.length > 240 ? `${venue?.data?.about.slice(0, 240)}...` : venue?.data?.about}
      </Text>
      {venue?.data?.about && venue?.data?.about.length > 240 && (
        <Button variant="link" fontSize="13px" mb="24px" position="relative">
          <Text
            position="absolute"
            left="0"
            top="4px"
            textDecoration="underline"
            onClick={() => setHideDetails(!hideDetails)}
          >
            {hideDetails ? 'Read more' : 'Hide'}
          </Text>
        </Button>
      )}

      {/* 
        <Text variant='title' mt='20px' mb='8px' fontSize='17'>Type of Court</Text>
        <Text variant='subtle' fontSize='13' mb='24px'>
            {venue?.data?.surface ?? ""}
        </Text> */}

      <Text variant="title" mt="20px" mb="8px" fontSize="17">
        Event Types
      </Text>
      <Text variant="subtle" fontSize="13" mb="24px">
        {venue?.data?.event_types.map((type: string) => getEventLabel(type)).join(', ') ?? 'None'}
        {venue?.data?.event_types.length == 0 ? 'None' : ''}
      </Text>

      <Text variant="title" mt="20px" mb="8px" fontSize="17">
        Hours of Operation
      </Text>
      <Text variant="subtle" fontSize="13" mb="30px">
        {formatTimeToAMPM(venue?.data?.opening_time)} - {formatTimeToAMPM(venue?.data?.closing_time)}
      </Text>
    </Box>
  )
}
const EventActions = ({ isMobile, venue }: { isMobile?: boolean; venue: any }) => {
  const navigate = useNavigate()

  return (
    <SimpleGrid w="100%" gap="12px" minChildWidth="100px" mt="20px" p={isMobile ? '0 20px' : '0'}>
      <Button
        variant="heavy"
        size={isMobile ? 'sm' : 'md'}
        onClick={() => window.open(getMapsUrl(venue?.data?.address))}
        leftIcon={
          <Icon w="21px" h="20px" viewBox="0 0 21 20" fill="none">
            <LocationMarkerDirection />
          </Icon>
        }
      >
        Directions
      </Button>
      <Button
        variant="outline"
        borderRadius="25px"
        size={isMobile ? 'sm' : 'md'}
        leftIcon={
          <Icon w="20px" h="20px" viewBox="0 0 20 20" fill="none">
            <SimpleLink />
          </Icon>
        }
        onClick={() => window.open(venue?.data?.website)}
        isDisabled={!venue?.data?.website}
      >
        Web
      </Button>
      <Button
        variant="outline"
        borderRadius="25px"
        size={isMobile ? 'sm' : 'md'}
        leftIcon={
          <Icon w="21px" h="20px" viewBox="0 0 21 20" fill="none">
            <MessageDots />
          </Icon>
        }
        onClick={() => navigate('/user/messages?to=staff')}
      >
        Contact
      </Button>
    </SimpleGrid>
  )
}

function convertTo12HourFormat(time24: string) {
  // Split the time into components
  let [hour, minute, _]: any = time24.split(':')

  //console.log("TO TWELVE")
  //console.log(time24)

  // Convert hour to number
  hour = parseInt(hour, 10)

  // Determine AM/PM
  const period = hour >= 12 ? 'PM' : 'AM'

  // Convert hour to 12-hour format
  hour = hour % 12
  hour = hour ? hour : 12 // the hour '0' should be '12'

  // Format the time in 12-hour format
  const formattedTime = `${hour}:${minute} ${period}`

  return formattedTime
}

const EventBook = ({
  firstEventDate,
  isMobile,
  embed_code,
  venueName,
  venueDates,
  onBookClick,
}: {
  firstEventDate: Date | null
  isMobile?: boolean
  embed_code: string
  venueName: string
  venueDates?: any
  onBookClick?: () => void
}) => {
  const datesWithEventsSet = useMemo<Set<string>>(() => {
    const dates = venueDates || []
    return new Set<string>(dates.map((item: any) => String(item.date)))
  }, [venueDates])

  const [timeframeDate, setTimeframeDate] = useState<Date | null>(new Date())
  const [containerWidth, containerRef] = useElementWidth<HTMLDivElement>()

  const [timeslot, setTimeslot] = useState(-1)

  const [available, setAvailable] = useState(false)

  const [dateSelected, setDateSelected] = useState(false)
  const [showDateHint, setShowDateHint] = useState(true)

  const isSmallDesktop = useMobile(1330)
  const [jankySolution, setJankySolution] = useState(0)

  const { id } = useParams()
  const toast = useToast()

  const { isOpen: isWaitlistOpen, onOpen: onOpenWaitlist, onClose: onCloseWaitlist } = useDisclosure()

  // const SKILL_LEVELS = ['Beginner', 'Intermediate', 'Intermediate High', 'Advanced', 'Advanced 4.5+', 'Mixed-Level']

  useEffect(() => {
    console.log(timeframeDate)
    console.log(dateSelected)
  }, [timeframeDate, dateSelected])

  useEffect(() => {
    console.log('DATE: ', firstEventDate)
    if (firstEventDate) {
      setTimeframeDate(firstEventDate)
    }
  }, [firstEventDate])

  // Reset time filter whenever the user changes the date (tag should not stay on)
  const prevTimeframeDateRef = useRef<Date | null>(timeframeDate)
  useEffect(() => {
    if (prevTimeframeDateRef.current !== null && timeframeDate !== null) {
      const prevStr = formatDate(prevTimeframeDateRef.current)
      const currStr = formatDate(timeframeDate)
      if (prevStr !== currStr) {
        setTimeslot(-1)
      }
    }
    prevTimeframeDateRef.current = timeframeDate
  }, [timeframeDate])

  const [timeslots, setTimeslots] = useState<string[]>([])

  const events = useInfiniteQuery(
    ['getVenueEvents', id, timeslot, timeframeDate, available],
    ({ pageParam = 1 }) =>
      getVenueEvents({
        id,
        filterParams: {
          time: (() => {
            const selectedTime = timeslot !== -1 ? timeslots[timeslot] : null
            if (!selectedTime) return null
            return `${
              parseInt(selectedTime.slice(0, 2)) +
              (selectedTime.slice(6, 8) === 'PM' && parseInt(selectedTime.slice(0, 2)) != 12 ? 12 : 0)
            }:${parseInt(selectedTime.slice(3, 5))}:00`
          })(),
          available_only: available,
          //min_date : new Date().toISOString(),
          date: dateSelected ? formatDate(timeframeDate) : null,
          page_size: 10,
          page: pageParam,
        },
      }),
    {
      refetchOnWindowFocus: false,

      getNextPageParam: (lastPage) => {
        if (!lastPage?.hasNext) {
          return null
        }
        return lastPage.nextCursor
      },
    },
  )

  const formattedTimeSlots = timeslots.map((timeSlot) => convertTo12HourFormat(timeSlot)) ?? []

  useEffect(() => {
    setJankySolution(jankySolution + 1)
  }, [])

  useEffect(() => {
    if (!events.isLoading && !events.isFetching) {
      let sortedTimeslots = events?.data?.pages?.[0].start_times ?? []

      // Sort the time slots in ascending order
      sortedTimeslots = sortedTimeslots.sort((a: any, b: any) => {
        const timeA = convertTo24HourFormat(a)
        const timeB = convertTo24HourFormat(b)
        return timeA.localeCompare(timeB)
      })

      // Keep the full list from the unfiltered request so tags don't disappear
      if (timeslot === -1) {
        setTimeslots(sortedTimeslots)
      }
    }
  }, [events, timeslot])
  function convertTo24HourFormat(time12: any) {
    let [hour, minute] = time12.split(':')
    const period = minute.slice(-2)
    minute = minute.slice(0, 2)
    hour = parseInt(hour)

    if (period === 'PM' && hour !== 12) {
      hour += 12
    }
    if (period === 'AM' && hour === 12) {
      hour = 0
    }

    return `${String(hour).padStart(2, '0')}:${minute}`
  }

  return (
    <Box w="100%" maxW="600px" ref={containerRef} p={isMobile ? '20px' : '0'}>
      <PlayWaitlistJoinedModal isOpen={isWaitlistOpen} onClose={onCloseWaitlist} />
      {isSmallDesktop && <Spacer h={isMobile ? '5px' : '20px'} />}
      <Box position="relative">
        {showDateHint && (
          <Box
            position="absolute"
            top="-40px"
            left="50%"
            transform="translateX(-50%)"
            bg="gray.700"
            color="white"
            fontSize="sm"
            px="12px"
            py="6px"
            borderRadius="md"
            whiteSpace="nowrap"
            zIndex={1}
            pointerEvents="none"
          >
            Tap on a date to filter events
            <Box
              position="absolute"
              bottom="-6px"
              left="50%"
              transform="translateX(-50%)"
              borderLeft="6px solid transparent"
              borderRight="6px solid transparent"
              borderTop="6px solid"
              borderTopColor="gray.700"
            />
          </Box>
        )}
        {isMobile ? (
          <DatePickerSwipe
            date={dateSelected ? timeframeDate : null}
            setDate={(newDate) => {
              setTimeframeDate(newDate)
              setDateSelected(newDate !== null)
              setShowDateHint(false)
              setTimeslot(-1)
            }}
            datesWithEventsSet={datesWithEventsSet}
          />
        ) : (
          <DatePicker
            daysPerPage={Math.floor((containerWidth ?? 1) / 60)}
            date={dateSelected ? timeframeDate : null}
            setDate={(newDate) => {
              setTimeframeDate(newDate)
              setDateSelected(newDate !== null)
              setShowDateHint(false)
              setTimeslot(-1)
            }}
            datesWithEventsSet={datesWithEventsSet}
          />
        )}
      </Box>

      <Flex
        justifyContent="space-between"
        alignItems="center"
        mt={isMobile ? '20px' : '30px'}
        mb={isMobile ? '5px' : '10px'}
        maxWidth="600px"
      >
        <Text variant="title" fontSize="15" fontWeight="400">
          Show available slots only
        </Text>
        <Switch onChange={() => setAvailable(!available)} isChecked={available} />
      </Flex>
      <CustomTags
        name="competitionLevel"
        value={timeslot}
        onChange={(v) => {
          setTimeslot(v)
        }}
        choices={formattedTimeSlots}
      />

      <Accordion defaultIndex={[0]} allowMultiple mt="10px">
        <AccordionItem>
          <h2>
            <AccordionButton px="0.5">
              <Box as="span" flex="1" textAlign="left">
                <Text variant="title" fontSize="17px">
                  Available Events
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} px={isMobile ? '0px' : '16px'}>
            <InfinityGrid
              onLoadMore={() => events.fetchNextPage()}
              isLoading={events.isLoading}
              hasNextPage={events.hasNextPage ?? false}
              isFetchingNextPage={events.isFetchingNextPage}
            >
              {getInfinityPages(events, 'events').length == 0 && events.isFetching == false ? (
                <BlankState
                  title="No events available"
                  description="No events at the moment"
                  image="/blank/No upcoming events 2.svg"
                />
              ) : (
                <></>
              )}

              {events.isFetching
                ? [1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map((_: any, index: number) => (
                    <>
                      {/* <Spacer h="20px" /> */}
                      <Skeleton key={index} h="317px" maxW="600px" w="100%" borderRadius="10px" mb="16px" />
                    </>
                  ))
                : getInfinityPages(events, 'events').map((row: any, index: number) => {
                    //if (row.status.status === "finished") return <></>
                    //if (row.status.status === "booked" && available) return <></>
                    return (
                      <>
                        <EventDetailCard
                          key={index}
                          id={row.id}
                          status={row.status?.status}
                          image={row.image}
                          time={new Date(row.start_time)}
                          location={venueName}
                          type={row.type}
                          secondary_type={row.secondary_type ?? null}
                          court={row.court}
                          level={getSkillLevelDisplay(row.skill_level)}
                          host={row.host}
                          coaches={row.coaches}
                          players={row.participants}
                          description={row?.description ?? ''}
                          price={parseFloat(row.fee)}
                          duration={row.duration}
                          onOpenWaitlist={onOpenWaitlist}
                          waitlistPosition={row.status?.position}
                          title={row.title}
                          onRefetch={() => events.refetch()}
                          isPrivate={row.is_private}
                          onBookClick={onBookClick}
                          onShare={() => {
                            const eventUrl = import.meta.env.VITE_LOCAL_ENDPOINT + `/event/${row.id}`
                            if (isMobile) {
                              navigator.share({
                                title: row.title || 'LVBL',
                                text: `Check out ${row.title || 'this event'} on LVBL!`,
                                url: eventUrl,
                              })
                            } else {
                              navigator.clipboard.writeText(eventUrl)
                              handleToast(toast, 'Link copied to clipboard!')
                            }
                          }}
                        />
                        <Spacer h="16px" />
                      </>
                    )
                  })}
            </InfinityGrid>
          </AccordionPanel>
        </AccordionItem>

        {embed_code && (
          <AccordionItem>
            <h2>
              <AccordionButton px="0.5">
                <Box as="span" flex="1" textAlign="left">
                  <Text variant="title" fontSize="17px">
                    Court Bookings
                  </Text>
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <Box>
                {embed_code && (
                  <>
                    <iframe src={embed_code} style={{ border: 0 }} width="100%" height="1600px"></iframe>
                  </>
                )}
              </Box>
            </AccordionPanel>
          </AccordionItem>
        )}
      </Accordion>
    </Box>
  )
}

const MobileMediaSection = ({ onShare, venue }: { onShare: () => void; venue: any }) => {
  const [thumbnailWidth, cardContainerRef] = useElementWidth<HTMLDivElement>()
  const isMobile = useMobile(600)

  return (
    <Box ref={cardContainerRef}>
      {venue.isFetching ? (
        <Skeleton
          w={(thumbnailWidth ?? 0) - (isMobile ? 0 : 0)}
          h={`${Math.round(((thumbnailWidth ?? 0) * 3) / 2)}px`}
          borderRadius={isMobile ? '0px' : '10px'}
        />
      ) : (
        <EventGalleryCard
          thumbnailWidth={(thumbnailWidth ?? 0) - (isMobile ? 0 : 0)}
          thumbnails={venue?.data?.images ?? []}
          h={`${Math.round(((thumbnailWidth ?? 0) * 3) / 2)}px`}
          hourlyPrice={venue?.data?.shortest_event?.fee ?? 0}
          shortestDuration={venue?.data?.shortest_event?.duration ?? 0}
          hasBackButton
          hasShareButton
          borderRadius={isMobile ? '0px' : '10px'}
          onShare={onShare}
        />
      )}
    </Box>
  )
}

const DesktopMediaSection = ({ onShare, venue }: { onShare: () => void; venue: any }) => {
  const [thumbnailWidth, cardContainerRef] = useElementWidth<HTMLDivElement>()
  const isSmallDesktop = useMobile(1330)

  const getBoxWidth = () => {
    if (isSmallDesktop) return '400px'

    return '599px'
  }

  return (
    <Box w={getBoxWidth()} ref={cardContainerRef}>
      {venue.isFetching ? (
        <Skeleton h={`${Math.round(((thumbnailWidth ?? 0) * 3) / 2)}px`} w="100%" borderRadius="10px" />
      ) : (
        <EventGalleryCard
          thumbnailWidth={thumbnailWidth}
          h={`${Math.round(((thumbnailWidth ?? 0) * 3) / 2)}px`}
          thumbnails={venue?.data?.images ?? []}
          hourlyPrice={venue?.data?.shortest_event?.fee ?? 0}
          shortestDuration={venue?.data?.shortest_event?.duration ?? 0}
          hasBackButton
          hasShareButton
          onShare={onShare}
        />
      )}

      <EventActions venue={venue} />

      <Box w="100%" h="302px" mt="10px" borderRadius="10px" overflow="hidden">
        <MapCard venue={venue} />
      </Box>

      {venue.data?.video && venue.data?.video != '' && (
        <Box w="100%" h="302px" mt="20px" borderRadius="10px" overflow="hidden">
          <iframe
            width="100%"
            height="100%"
            src={venue.data?.video.replace('youtu.be', 'youtube.com/embed')}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Box>
      )}
    </Box>
  )
}

const DesktopDetailsSection = ({
  venue,
  firstEventDate,
  onBookClick,
}: {
  venue: any
  firstEventDate: Date | null
  onBookClick?: () => void
}) => {
  const isSmallDesktop = useMobile(1330)

  const getBoxWidth = () => {
    if (isSmallDesktop) return 'calc(100% - 30px - 400px)'
    return 'calc(100% - 30px - 599px)'
  }

  useEffect(() => {
    console.log('venue data:', venue)
    console.log('start time:', venue.data?.first_start_time)
  }, [venue.data])

  return (
    <Box
      w={getBoxWidth()}
      position="sticky"
      top="0"
      maxHeight="100vh"
      overflowY="auto"
      css={{
        '&::-webkit-scrollbar': {
          width: '0px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
        },
      }}
    >
      {venue.isLoading || venue.isFetching ? (
        <>
          <Skeleton height="24px" width="250px" mt="2px" mb="8px" />
          <Skeleton height="16px" width="350px" mb="24px" />
        </>
      ) : (
        <>
          <Text variant="title" mt="2px" mb="8px">
            {venue?.data?.name ?? ''}
          </Text>
          <Text variant="subtle" fontSize="13" mb="24px">
            {venue?.data?.address ?? ''}
          </Text>
        </>
      )}
      <EventDetails venue={venue} />
      <EventBook
        firstEventDate={firstEventDate}
        embed_code={venue?.data?.embed_code ?? ''}
        venueName={venue?.data?.name ?? ''}
        venueDates={venue?.data?.dates || []} // Provide default empty array
        onBookClick={onBookClick}
      />
    </Box>
  )
}

const UserPlayExpandPage = () => {
  const isTablet = useMobile(1110)
  const isMobile = useMobile(600)
  const toast = useToast()

  //const [thumbnailWidth,cardContainerRef] = useElementWidth<HTMLDivElement>()

  const { id } = useParams()
  const navigate = useNavigate()
  const { user, error } = useContext(AuthContext)

  const handleBookClick = () => {
    if (!user || error) {
      localStorage.setItem('redirectAfterLogin', `/user/play/${id}`)
      navigate('/auth/login')
      return 'redirected' // Explicit non-null return to signal "handled"
    }
    return null // Signal "continue with default behavior"
  }

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const eventId = queryParams.get('eventId')
  const [selectedDate, setSelectedDate] = useState<Date | null>(null)

  // Redirect old eventId query parameter format to new nested route
  useEffect(() => {
    if (eventId && id) {
      // Redirect to the new event share page format
      navigate(`/user/play/${id}/event/${eventId}`, { replace: true })
    }
  }, [eventId, id, navigate])
  const { isOpen: isCopyLinkOpen, onOpen: onOpenCopyLink, onClose: onCloseCopyLink } = useDisclosure()

  const handleOpenCopyLink = () => {
    if (isMobile) {
      navigator.share({
        title: 'LVBL',
        text: 'Check out this location on LVBL',
        url: import.meta.env.VITE_LOCAL_ENDPOINT + `/#/user/play/${id}`, // URL to share ,
      })
    } else onOpenCopyLink()
  }

  const [tabIndex, setTabIndex] = useState(1)

  const venue = useQuery(['getVenueDetail', id], () => getVenueDetail({ id }), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      // Find the date for the given eventId
      if (eventId && data?.dates) {
        const eventDate = data.dates.find((dateObj: any) => dateObj.ids.includes(eventId))
        if (eventDate) {
          setSelectedDate(new Date(eventDate.date))
        }
      } else {
        // Set to first available date if no eventId
        if (data?.first_start_time) {
          setSelectedDate(new Date(data.first_start_time))
        }
      }
    },
  })

  if (isTablet)
    return (
      <Box w="100%" p={isMobile ? '0' : '30px'}>
        <CopyLinkModal
          link={`/#/user/play/${id}`}
          isOpen={isCopyLinkOpen}
          onClose={onCloseCopyLink}
          onCopyLink={() => {
            handleToast(toast, 'Link copied to clipboard!')
            onCloseCopyLink()
          }}
          caption="Check out this location on LVBL!"
          //image={(venue.data?.images.length > 0) ? venue?.data?.images[0] : ""}
        />
        <MobileMediaSection onShare={() => handleOpenCopyLink()} venue={venue} />
        {venue.isLoading || venue.isFetching ? (
          <>
            <Skeleton height="24px" width="200px" mt="10px" mb="8px" ml={isMobile ? '20px' : '0'} />
            <Skeleton height="16px" width="300px" mb={isMobile ? '12px' : '24px'} ml={isMobile ? '20px' : '0'} />
          </>
        ) : (
          <>
            <Text variant="title" mt="10px" mb="8px" ml={isMobile ? '20px' : '0'}>
              {venue?.data?.name}
            </Text>
            <Text variant="subtle" fontSize="13" mb={isMobile ? '12px' : '24px'} ml={isMobile ? '20px' : '0'}>
              {venue?.data?.address}
            </Text>
          </>
        )}
        <Tabs index={tabIndex} onChange={(i) => setTabIndex(i)}>
          <TabList justifyContent="space-evenly">
            <CustomTab>About</CustomTab>
            <CustomTab>Book</CustomTab>
          </TabList>
        </Tabs>

        {tabIndex === 0 ? (
          <>
            <EventDetails venue={venue} isMobile={isMobile} />
            <EventActions isMobile={isMobile} venue={venue} />
            <Box w="100%" h="302px" mt="10px" borderRadius={isMobile ? 0 : '10px'} overflow="hidden">
              <MapCard venue={venue} />
            </Box>
            {venue.data?.video && venue.data?.video != '' && (
              <Box w="100%" h="302px" mt="20px" borderRadius={isMobile ? 0 : '10px'} overflow="hidden">
                <iframe
                  width="100%"
                  height="100%"
                  src={venue.data?.video ?? 'https://www.youtube.com/embed/oyxhHkOel2I?si=BeZvviR7GyrhthLE'}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </Box>
            )}
          </>
        ) : (
          <>
            <EventBook
              isMobile={isMobile}
              embed_code={venue?.data?.embed_code ?? ''}
              firstEventDate={selectedDate}
              venueName={venue?.data?.name ?? ''}
              venueDates={venue?.data?.dates || []} // Provide default empty array
              onBookClick={handleBookClick}
            />
          </>
        )}
      </Box>
    )

  return (
    <Flex
      p="30px"
      gap="30px"
      alignItems="flex-start"
    >
      <CopyLinkModal
        link={`/#/user/play/${id}`}
        isOpen={isCopyLinkOpen}
        onClose={onCloseCopyLink}
        onCopyLink={() => {
          handleToast(toast, 'Link copied to clipboard!')
          onCloseCopyLink()
        }}
        caption="Check out this location on LVBL!"
        //image={(venue.data?.images.length > 0) ? venue?.data?.images[0] : ""}
      />
      <DesktopMediaSection venue={venue} onShare={() => handleOpenCopyLink()} />
      <DesktopDetailsSection venue={venue} firstEventDate={selectedDate} onBookClick={handleBookClick} />
    </Flex>
  )
}

export default UserPlayExpandPage
